export default (function (_ref) {
  var request = _ref.request;
  return {
    breedProductManageAdd: function breedProductManageAdd(data) {
      return request({
        url: '/cms/breedProductManage/add',
        method: 'post',
        data: data
      });
    },
    breedProductManageModify: function breedProductManageModify(data) {
      return request({
        url: "/cms/breedProductManage/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    breedProductManageDel: function breedProductManageDel(id) {
      return request({
        url: "/cms/breedProductManage/".concat(id, "/del"),
        method: 'delete'
      });
    },
    breedProductManageQuery: function breedProductManageQuery(data) {
      return request({
        url: '/cms/breedProductManage',
        method: 'get',
        params: data
      });
    },
    breedProductManageDetail: function breedProductManageDetail(id) {
      return request({
        url: "/cms/breedProductManage/".concat(id),
        method: 'get'
      });
    }
  };
});